import { SkeletonText, SkeletonTable } from '@dev-spendesk/grapes';
import React from 'react';

export const CardLimitsTableLoader = () => {
  return (
    <div className="mt-24 w-full">
      <SkeletonTable
        columns={[
          {
            cell: <SkeletonText width="100%" />,
            header: <SkeletonText width="100%" />,
          },
        ]}
        numberOfRows={2}
        withHeader
      />
    </div>
  );
};
